import 'normalize.css'
import './styles/root.scss'

import Homepage from "./pages/Homepage";

export default function App() {
  return (
   <Homepage/>
  );
}
